import loadAndInitThree from 'src/scripts/loadAndInitThree';

const stackedCards = (): void => {
  const selectors = {
    accordionSection: '[data-stacked-cards]',
    accordionAccordion: '[data-accordion]',
    accordionAccordionHeading: '[data-accordion-heading]',
    accordionAccordionContent: '[data-accordion-content]',
    accordionIndex: '[data-accordion-index]',
    triggerIndex: '[data-accordion-trigger-index]',
    threeDContainer: '[data-3d-container]',
    threeDContainerObject: 'data-3d-object',
  };

  const classes = {
    accordionOpen: 'stacked-cards__accordion--open',
  };

  const openAccordion = (
    accordion: HTMLElement,
    accordionInner: HTMLElement
  ): void => {
    accordion.classList.add(classes.accordionOpen);
    accordionInner.style.maxHeight = accordionInner.scrollHeight + 'px';
  };

  const closeAccordion = (
    accordion: HTMLElement,
    accordionInner: HTMLElement
  ): void => {
    accordion.classList.remove(classes.accordionOpen);
    accordionInner.style.maxHeight = null as any;
  };

  const accordionSections = document.querySelectorAll<HTMLElement>(
    selectors.accordionSection
  );

  accordionSections.forEach((section) => {
    const accordions = section.querySelectorAll<HTMLElement>(
      selectors.accordionAccordion
    );

    accordions.forEach((accordion) => {
      const heading = accordion.querySelector<HTMLElement>(
        selectors.accordionAccordionHeading
      );
      const content = accordion.querySelector<HTMLElement>(
        selectors.accordionAccordionContent
      );

      if (heading && content) {
        // Open on Load
        if (accordion.getAttribute('data-accordion') == 'open-on-load') {
          openAccordion(accordion, content);
        }

        heading.addEventListener('click', () => {
          if (content.style.maxHeight) {
            closeAccordion(accordion, content);
          } else {
            accordions.forEach((otherAccordion) => {
              const otherContent: any =
                otherAccordion.querySelector<HTMLElement>(
                  selectors.accordionAccordionContent
                );
              closeAccordion(otherAccordion, otherContent);
            });
            openAccordion(accordion, content);
          }
        });
      }
    });

    window.addEventListener('resize', () => {
      accordions.forEach((accordion: HTMLElement) => {
        const content = accordion.querySelector<HTMLElement>(
          selectors.accordionAccordionContent
        );
        if (content && content.style.maxHeight) {
          openAccordion(accordion, content);
        }
      });
    });

    // 3D
    const ioSupported = 'IntersectionObserver' in window;
    const observer = ioSupported
      ? new IntersectionObserver(
          (entries, io) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              const el = entry.target as HTMLElement;
              const objectName =
                el.getAttribute(selectors.threeDContainerObject) || '';
              loadAndInitThree(el, objectName);
              io.unobserve(el); // run once
            });
          },
          {
            // Preload a bit before it’s actually on screen
            root: null,
            rootMargin: '200px 0px',
            threshold: 0.15, // ~15% visible
          }
        )
      : null;

    const threeDContainers = section.querySelectorAll<HTMLElement>(
      selectors.threeDContainer
    );

    threeDContainers.forEach((container) => {
      const threeDObject =
        container.getAttribute(selectors.threeDContainerObject) || '';
      if (observer) {
        observer.observe(container);
      } else {
        void loadAndInitThree(container, threeDObject);
      }
    });
  });
};

export default stackedCards;
